import { createSlice } from '@reduxjs/toolkit'
const initVal = {

        

  base: "small",
  chk:true,
  crust: "",
  sauce: "",
  cheese: "no_cheese",
  

  prevCustomers:[],//onceki sonraki arasinda gezmek icin
  nextCustomers:[],//onceki sonraki arasinda gezmek icin

  headerCallCustomerId:0,//search boxdan secili bir kisi icin datapage sekillenecekse
  projectUserId:0,//eger secili bir proje icin kullanicilari gezecekse
  projectName:"",
  projectId:0,
  fairId:0,
  activeCustomerId:0,//uzerinden islem yapilan kullanici
  name: '',
  surname:'',
  email:[],
  phone:[],
  gsm:[],  
  countryList:[],
  selectedCountry:'',
  selectedCity:'',
  cityList:[],
  company:{},
  position:{}, 
  pdpApproval:false,
  smsValidation:false,
  emailValidation:false,
  description:'',

  firstLoadSelectedCompanyDetail:false,
  sectorId:'',
  sectorList:[],
  subSectorId:'',
  subSectorList:[],
  revanue:'',
  storeCount:'',
  productKeyword:"",
  manufacturer:false,
  wholesaler:false,
  importer:false,
  designer:false,
  retail:false,
  other:false,
  
  selectedFair:0,
  selectedInterviewSubject:'',
  selectedInterviewResult:'',
  interviewDescription:'',
  interviewList:[],

  isCompanySelected:false,
  refreshMyTask:false


};
const reducerKgo = createSlice({
  name: "root",
  initialState: initVal,

  reducers: {
   
    chooseResetToInitVal: (state, action) => initVal,

    chooseBase: (state, action) => { state.base = action.payload },
    chooseChk: (state, action) => { state.chk = action.payload },
    chooseCrust: (state, action) => { state.crust = action.payload },
    chooseSauce: (state, action) => { state.sauce = action.payload },
    chooseCheese: (state, action) => { state.cheese = action.payload },
    
    chooseHeaderCallCustomerId: (state, action) => { state.headerCallCustomerId = action.payload; },

    chooseActiveCustomerId: (state, action) => { state.activeCustomerId = action.payload },

    chooseProjectUserId: (state, action) => { state.projectUserId = action.payload },

    chooseProjectName: (state, action) => { state.projectName = action.payload },
    chooseProjectId: (state, action) => { state.projectId = action.payload },

    chooseProjectFairId: (state, action) => { state.fairId = action.payload },
    

    pushToPrevCustomer:(state, action) => { state.prevCustomers.push(action.payload); },
    pushToNextCustomer:(state, action) => { state.nextCustomers.push(action.payload); },
    popToPrevCustomer:(state, action) => { const newArray = [...state.prevCustomers];state.prevCustomers=newArray.slice(0,-1); },
    popToNextCustomer:(state, action) => {  const newArray = [...state.nextCustomers];state.nextCustomers=newArray.slice(0,-1);  },


    chooseName: (state, action) => { state.name = action.payload },
    chooseSurname: (state, action) => { state.surname = action.payload },
    chooseEmail: (state, action) => { state.email = action.payload },
    choosePhone: (state, action) => { state.phone = action.payload },
    chooseGsm: (state, action) => { state.gsm = action.payload },
    chooseCity: (state, action) => { state.selectedCity = action.payload },
    chooseCountry: (state, action) => { state.selectedCountry = action.payload },
    chooseCityList: (state, action) => { state.cityList = action.payload },
    chooseCountryList: (state, action) => { state.countryList = action.payload },
    chooseCompany: (state, action) => { state.company = action.payload;state.firstLoadSelectedCompanyDetail=true; },
    choosePosition: (state, action) => { state.position = action.payload },
    choosePdpApproval: (state, action) => { state.pdpApproval = action.payload },
    chooseEmailValidation: (state, action) => { state.emailValidation = action.payload },
    chooseSmsValidation: (state, action) => { state.smsValidation = action.payload },
    chooseDescription: (state, action) => { state.description = action.payload },
    




    //
    chooseFirstLoadSelectedCompanyDetail: (state, action) => { state.firstLoadSelectedCompanyDetail = action.payload },
    chooseIsCompanySelected: (state, action) => { state.isCompanySelected = action.payload },

  chooseInterviewList :(state, action) => {state.interviewList = action.payload },

    // chooseSectorId: (state, action) => { state.sectorId = action.payload },
    // chooseSubSectorId: (state, action) => { state.subSectorId = action.payload },
    // chooseRevanue: (state, action) => { state.revanue = action.payload },
    // chooseStoreCount: (state, action) => { state.storeCount = action.payload },
    // chooseProductKeyword: (state, action) => { state.productKeyword = action.payload },
    // chooseManufacturer: (state, action) => { state.manufacturer = action.payload },
    // chooseWholeSaler: (state, action) => { state.wholesaler = action.payload },
    // chooseImporter: (state, action) => { state.importer = action.payload },    
    // chooseDesigner: (state, action) => { state.designer = action.payload },
    // chooseRetail: (state, action) => { state.retail = action.payload },
    // chooseOther: (state, action) => { state.other = action.payload },




    chooseSectorId: (state, action) => { state.company.sectorId = action.payload },
    chooseSubSectorId: (state, action) => { state.company.subSectorId = action.payload },
    chooseRevanue: (state, action) => { state.company.revanue = action.payload },
    chooseStoreCount: (state, action) => { state.company.storeCount = action.payload },
    chooseProductKeyword: (state, action) => { state.company.productKeyword = action.payload },
    chooseManufacturer: (state, action) => { state.company.manufacturer = action.payload },
    chooseWholeSaler: (state, action) => { state.company.wholesaler = action.payload },
    chooseImporter: (state, action) => { state.company.importer = action.payload },    
    chooseDesigner: (state, action) => { state.company.designer = action.payload },
    chooseRetail: (state, action) => { state.company.retail = action.payload },
    chooseOther: (state, action) => { state.company.other = action.payload },



   
    chooseSelectedFair: (state, action) => { state.selectedFair = action.payload },
    chooseSelectedInterviewSubject: (state, action) => { state.selectedInterviewSubject = action.payload },    
    chooseSelectedInterviewResult: (state, action) => { state.selectedInterviewResult = action.payload },
    chooseInterviewDescription: (state, action) => { state.interviewDescription = action.payload },

    chooseSectorList: (state, action) => { state.sectorList = action.payload },
    chooseSubSectorList: (state, action) => { state.subSectorList = action.payload },
    chooseRefreshMyTask: (state, action) => { state.refreshMyTask = action.payload },
    

    resetDemographic: (state, action) => {
      state.firstLoadSelectedCompanyDetail=false;
      state.sectorId = '';
      state.subSectorId = '';
      state.revanue = '';
      state.storeCount = '';
      state.productKeyword = '';
      state.manufacturer = false;
      state.wholesaler = false;
      state.importer = false;
      state.designer = false;
      state.retail = false;
      state.other = false;
      state.isCompanySelected = false;

    },
    resetGeneralData: (state, action) => {
      state.name = '';
      state.surname = '';
      state.email = '';
      state.phone = '';
      state.gsm = '';
      state.selectedCountry = '';
      state.selectedCity = '';
      state.cityList = [];
      state.countryList = [];
      state.company = {};
      state.position = {};
      state.pdpApproval = false;
      state.emailValidation = false;
      state.smsValidation = false;
      state.description = '';
   }
   








  }
})



export const { chooseBase, chooseCheese, chooseCrust, chooseSauce,chooseChk,

  chooseResetToInitVal,

  chooseHeaderCallCustomerId,
  chooseActiveCustomerId,
  chooseProjectUserId,
  chooseProjectName,
  chooseProjectId,
  chooseProjectFairId,
  pushToPrevCustomer,
  pushToNextCustomer,
  popToPrevCustomer,
  popToNextCustomer,
  chooseName,
  chooseSurname,
  chooseEmail,
  choosePhone,
  chooseGsm,
  chooseCity,
  chooseCountry,
  chooseCityList,
  chooseCountryList ,
  chooseCompany,
  choosePosition,
  choosePdpApproval,
  chooseEmailValidation,
  chooseSmsValidation,
  chooseDescription,

  chooseFirstLoadSelectedCompanyDetail,
  chooseIsCompanySelected,
  chooseSectorId,
    chooseSubSectorId,
    chooseRevanue,
    chooseStoreCount,
    chooseProductKeyword,
    chooseManufacturer,
    chooseWholeSaler,
    chooseImporter,
    chooseDesigner,
    chooseRetail,
    chooseOther,

    chooseSelectedFair,
    chooseSelectedInterviewSubject,
    chooseSelectedInterviewResult,
    chooseInterviewDescription,
    resetGeneralData,
    resetDemographic,
    chooseSectorList,
    chooseSubSectorList,
    chooseInterviewList,
    chooseRefreshMyTask


} = reducerKgo.actions

export default reducerKgo.reducer;